import { BrandOverlayEntity, RoomId, roomId } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomBrandOverlayDeleteVO {
  private static validation = JsonSchemaValidator.compile(
    RoomBrandOverlayDeleteVO.validationSchema(),
    BrandOverlayEntity
  );

  constructor(readonly value: RoomBrandOverlayDelete) {
    JsonSchemaValidator.assert(RoomBrandOverlayDeleteVO.validation, value);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId", "brandOverlay"],
      properties: {
        roomId,
        brandOverlay: {
          instanceof: BrandOverlayEntity.name
        }
      },
      additionalProperties: false
    };
  }
}

interface RoomBrandOverlayDelete {
  roomId: RoomId;
  brandOverlay: BrandOverlayEntity;
}
